<siat-calendar-toolbar
  [collaboratoriItems]="collaboratoriItems()"
  [collaboratoreFormGroup]="collaboratoreFormGroup()"
  [collaboratoreControlName]="collaboratoreControlName()"
  [showCollaboratoreSelect]="showCollaboratoreSelect()"
  [periodLabel]="currentPeriodLabel()"
  [viewOptions]="viewOptions()"
  [viewMode]="resolvedPrimaryToggleValue()"
  [secondaryViewOptions]="secondaryViewOptions()"
  [secondaryViewMode]="secondaryViewMode()"
  [datePickerGranularity]="datePickerGranularity()"
  [showAddButton]="showAddButton()"
  [addButtonOptions]="addButtonOptions()"
  [addButtonDisabled]="addButtonDisabled()"
  (navigate)="onCalendarNav($event)"
  (viewModeChange)="viewModeChange.emit($event)"
  (secondaryViewModeChange)="secondaryViewModeChange.emit($event)"
  (addNew)="addNew.emit($event)"
  (dateSelected)="goToSpecificDate($event)"
  class="mt-4"
/>

<ng-content />
